module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAaVBMVEVHcEz/////////////////////////////////////////////////////////////////////////////////////////////////////////////////7OP/aCb/jVz/8+3/oHb/t5j0ogn7AAAAHHRSTlMA7IZdmTlMjWCf+yc4zMJY+IucOhkTcXQmH2NJt78/ZwAAAHlJREFUKM/l0zcOgDAMQFEgEEoooTdT739IBgyKZIsRBv5k6Q0ZYlvWxykRkIS6tIyAKYqRHWBzkH2e/d/zOpFWg7eZtBm8L6T95px/O0ceec6uD8+K8EwDaByLga6NDWA/bNUTd1KmSZJK2bPculjDch17Z9VLB3IADXsrZdMftzwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home.png
// module id = gAJj
// module chunks = 1